import { is3pProductKey, ProductKeys } from '../product-keys';
import type { FilterId } from './index';

type InlineFilterIds = [] | [FilterId] | [FilterId, FilterId];

const INLINE_FILTER_IDS_BY_PRODUCT: Partial<Record<ProductKeys, InlineFilterIds>> = {
	[ProductKeys.Confluence]: ['space', 'contributor'],
	[ProductKeys.Jira]: ['project', 'contributor'],
	[ProductKeys.Atlas]: [],
};

const INLINE_FILTER_IDS_FOR_THIRD_PARTY_PRODUCTS: InlineFilterIds = ['contributor'];

// Placement only — callers must intersect with the visible set from getExcludedFilterIds.
export const inlineFilterIdsFor = (selectedProduct: ProductKeys | undefined): FilterId[] => {
	if (!selectedProduct) {
		return [];
	}

	const mapped = INLINE_FILTER_IDS_BY_PRODUCT[selectedProduct];
	if (mapped) {
		return mapped;
	}

	return is3pProductKey(selectedProduct) ? INLINE_FILTER_IDS_FOR_THIRD_PARTY_PRODUCTS : [];
};
